import React from 'react';
import { FormInput } from '~/components/FormComponents/FormInput';
import { useFormContext } from 'react-hook-form';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface IIdentificationNumberBlockProps {
  isDisabledForm?: boolean;
  section?: string;
  onBlur?: (fieldName: string) => void;
}

const IdentificationNumberBlock = ({
  section,
  isDisabledForm,
  onBlur,
}: IIdentificationNumberBlockProps) => {
  const methods = useFormContext();

  if (!methods) return null;

  const { trigger } = methods;
  const prefix = section ? section + '.' : '';

  const handleBlur = (fieldName: string, dependentName: string) => {
    onBlur?.(fieldName);
    trigger(prefix + dependentName);
  };

  return (
    <>
      <FormGridItem>
        <FormInput
          name={`${prefix}identificationNumber`}
          disabled={isDisabledForm}
          onBlur={() => handleBlur('identificationNumber', 'foreignTaxNumber')}
          label="РНОКПП (за наявності)"
          placeholder="Введіть РНОКПП"
          fullWidth
          inputProps={{
            maxLength: 10,
          }}
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`${prefix}foreignTaxNumber`}
          disabled={isDisabledForm}
          onBlur={() => handleBlur('foreignTaxNumber', 'identificationNumber')}
          label="Номер платника податків-для нерезидентів (за наявності)"
          placeholder="Введіть номер платника податків-для нерезидентів"
          fullWidth
        />
      </FormGridItem>
    </>
  );
};

export default React.memo(IdentificationNumberBlock);
